import { MESSAGE_TYPE } from 'widget/helpers/constants';
import { isASubmittedFormMessage } from 'shared/helpers/MessageTypeHelper';
import getUuid from '../../../helpers/uuid';

export const createTemporaryMessage = ({ attachments, content, replyTo }) => {
  const timestamp = new Date().getTime() / 1000;
  return {
    id: getUuid(),
    content,
    attachments,
    status: 'in_progress',
    replyTo,
    created_at: timestamp,
    message_type: MESSAGE_TYPE.INCOMING,
  };
};

const getSenderName = message => message.sender?.name || '';

const shouldShowAvatar = (message, nextMessage) => {
  const currentSender = getSenderName(message);
  const nextSender = getSenderName(nextMessage);

  return (
    currentSender !== nextSender ||
    message.message_type !== nextMessage.message_type ||
    isASubmittedFormMessage(nextMessage)
  );
};

export const groupConversationBySender = conversationsForADate =>
  conversationsForADate.map((message, index) => {
    let showAvatar;
    const isLastMessage = index === conversationsForADate.length - 1;
    if (isASubmittedFormMessage(message)) {
      showAvatar = false;
    } else if (isLastMessage) {
      showAvatar = true;
    } else {
      const nextMessage = conversationsForADate[index + 1];
      showAvatar = shouldShowAvatar(message, nextMessage);
    }
    return { ...message, showAvatar };
  });

export const findUndeliveredMessage = (messages, { content }) =>
  messages.filter(
    message => message.content === content && message.status === 'in_progress'
  );

export const getNonDeletedMessages = ({ messages }) => {
  return messages.filter(
    item => !(item.content_attributes && item.content_attributes.deleted)
  );
};

export const ensureConversation = (state, conversationId) => {
  if (!conversationId) {
    return null;
  }
  const idStr = String(conversationId);
  if (!state.details[idStr]) {
    state.details[idStr] = {
      id: null,
      account_id: null,
      inbox_id: null,
      status: '',
      assignee_id: null,
      created_at: '',
      updated_at: '',
      contact_id: null,
      display_id: conversationId,
      messages: {},
      additional_attributes: {
        browser: {
          device_name: '',
          browser_name: '',
          platform_name: '',
          browser_version: '',
          platform_version: '',
        },
        referer: null,
        initiated_at: {
          timestamp: '',
        },
        browser_language: '',
        contact_inbox_id: null,
        uuid: '',
        identifier: null,
        last_activity_at: '',
        team_id: null,
        campaign_id: null,
        snoozed_until: null,
        custom_attributes: {},
        assignee_last_seen_at: '',
        first_reply_created_at: '',
        priority: null,
        sla_policy_id: null,
        waiting_since: '',
        cached_label_list: '',
        provider_conversation_id: null,
        label_list: [],
        last_non_activity_message: null,
      },
      meta: {
        sender: null,
        assignee: null,
        channel: '',
        hmac_verified: false,
        unread_count: 0,
        contact_last_seen_at: '',
      },
      uiFlags: {
        allMessagesLoaded: false,
        isFetchingList: false,
        isAgentTyping: false,
        isCreating: false,
      },
    };
  }
  return state.details[idStr];
};
